export const NAME = 'financial';
